import * as qs from "query-string";
import * as router from "react-router-redux";

const INITIAL_STATE = {};

export function getQueryStringState(state) {
    return state.queryString;
}

export default function queryString(state = INITIAL_STATE, action) {
    switch (action.type) {
        case router.LOCATION_CHANGE:
            return action.payload.search
                ? qs.parse(action.payload.search)
                : INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/queryString.js